import { ActionTree } from 'vuex';
import { ITagState } from './tag.store';
import {
  mutationAddTag,
  mutationSetTags,
  mutationSetLoading,
  mutationSetLoaded,
} from '@/tags/store/tag.mutations';
import { RootState } from '@/store/store';
import { ITag } from '@/types/Tag';
import service from '@/tags/services/tag.service';
import { translate } from '@/helpers/translation.helper';

export const actionCreateTag = 'createTag';
export const actionCreateTagSuccess = 'createTagSuccess';
export const actionCreateTagFailed = 'createTagFailed';
export const actionLoadTags = 'loadTags';
export const actionLoadTagsSuccess = 'loadTagsSuccess';
export const actionLoadTagsFailed = 'loadTagsFailed';

export const actions: ActionTree<ITagState, RootState> = {
  async [actionCreateTag]({ dispatch, commit }, name: string) {
    commit(mutationSetLoading, true);
    try {
      const createdTag: ITag = await service.createTag(name);
      dispatch(actionCreateTagSuccess, createdTag);
    } catch (error) {
      dispatch(actionCreateTagFailed, error);
    }
    commit(mutationSetLoading, false);
  },
  async [actionCreateTagSuccess]({ commit }, createdTag: ITag) {
    commit(mutationAddTag, createdTag);
  },
  async [actionCreateTagFailed]({ dispatch }) {
    dispatch('alert/showDangerAlert', translate('Could-not-create-new-tag'), {
      root: true,
    });
  },
  async [actionLoadTags]({ dispatch, commit }) {
    commit(mutationSetLoading, true);
    try {
      const tags: ITag[] = await service.getTags();
      dispatch(actionLoadTagsSuccess, tags);
    } catch (error) {
      dispatch(actionLoadTagsFailed);
    }
  },
  async [actionLoadTagsSuccess]({ commit }, tags: ITag[]) {
    commit(mutationSetTags, tags);
    commit(mutationSetLoaded, true);
    commit(mutationSetLoading, false);
  },
  async [actionLoadTagsFailed]({ dispatch, commit }) {
    commit(mutationSetLoaded, false);
    commit(mutationSetLoading, false);
    dispatch('alert/showDangerAlert', translate('could-not-load-tags'), {
      root: true,
    });
  },
};
